<template>
  <div class="e-extra-as-badge">
    <div>
      <span v-if="item.optionCode">{{ item.optionCode }}&nbsp;-</span>
      {{ item.name }}
    </div>
    <strong v-if="item.price">:&nbsp;€{{ calculatedPrice }}</strong>
  </div>
</template>

<script>
import * as lib from '../../../lib/lib'

export default {
  props: {
    id: {
      required: true,
      type: String,
    },
    options: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {
      lang: 'en',
    }
  },
  computed: {
    item() {
      return this.options.find((x) => x.optionId === this.id)
    },
    calculatedPrice() {
      if (!this.configuration.vat) {
        return this.item.price.toLocaleString(this.lang)
      }
      const vat = this.configuration.vat / 100 + 1
      return (this.item.price * vat).toLocaleString(this.lang)
    },
  },
  mounted() {
    this.lang = lib.getLocaleFromLangAttr()
  },
}
</script>
